export default __webpack_public_path__ + "static/media/usd icon 1.3c3c8513.svg";